import React from 'react';
import Text from '../ui/Text';
import Wrapper from '../ui/Wrapper';
import styled from 'styled-components';
import InfoBlue from '../images/icons/info_circle.svg';

const InfoIcon = styled.img`
    margin-right: 10px;
`;

export const NoEventsMessage = () => {
    return (
        <Text padding={'10px'} color={'#444'} weight={'bold'} bg={'#fff'}>
            Ingen begivenheder fundet.
        </Text>
    );
};

export const NoEventsMessageBlue = ({ showLongMessage }) => {
    return (
        <Wrapper
            bgColor="#EAF1FE"
            border="1px solid #AFCCFA"
            borderRadius="8px"
            padding="16px"
            margin={'10px'}
            flex
            flexAlign={'center'}
        >
            <InfoIcon src={InfoBlue} height={'18px'} width={'18px'} />
            <div>
                <Text
                    size={'12'}
                    lh={'20'}
                    weight={'400'}
                    color={'#1E1E1E'}
                    padding={'0'}
                >
                    <strong>Ingen begivenheder fundet</strong>
                    {showLongMessage && (
                        <>
                            <br />
                            Beklager, der er i øjeblikket ingen tilgængelige
                            kampe at vise. Dette kan også skyldes en teknisk
                            fejl fra vores side. Venligst prøv igen senere eller
                            kontroller din forbindelse og opdater siden.
                        </>
                    )}
                </Text>
            </div>
        </Wrapper>
    );
};
